import { z } from 'zod'
import { del, get, post } from '../axios'
import { appCatalogPage, appConnection, appToolPage, ConfigureToolsInput, connectionStart, toolProposal } from './types'

function pageQuery(search: string, cursor: string | null) {
    const params = new URLSearchParams({ search })

    if (cursor) {
        params.set('cursor', cursor)
    }

    return params
}

export function fetchAppConnections() {
    return get(appConnection.array(), 'app-connections')
}

export function fetchAppCatalog(search: string, cursor: string | null) {
    return get(appCatalogPage, `app-connections/catalog?${pageQuery(search, cursor)}`)
}

export function fetchAppTools(connectionId: string, search: string, cursor: string | null) {
    return get(appToolPage, `app-connections/${connectionId}/tools?${pageQuery(search, cursor)}`)
}

export function connectApp(toolkit: string) {
    return post(connectionStart, 'app-connections', { toolkit })
}

export function disconnectApp(connectionId: string) {
    return del(z.unknown(), `app-connections/${connectionId}`)
}

export function completeAppConnection(connectionId: string, state: string) {
    return post(appConnection, `app-connections/${connectionId}/complete`, { state })
}

export function configureTools(input: ConfigureToolsInput) {
    return post(toolProposal, 'app-connections/configure', input)
}
